import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import PortalPopup from "../../components/PortalPopup";
import NavigationPanel from "../../components/NavigationPanel";
import Footer from "../../components/Footer";
import SettingNav from "../../components/settingNav";
import ToastMsg from "../../components/ToastMsg";
import TabState from "../../components/TabState";

const SettingsAccount4Page = () => {
  const navigate = useNavigate();
  const [isToastMsgOpen, setToastMsgOpen] = useState(false);
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [password, setPassword] = useState("");

  const closeLogoutConfirmation = useCallback(
    () => setLogoutConfirmationOpen(false),
    [],
  );
  const openToastMsg = useCallback(() => setToastMsgOpen(true), []);
  const closeToastMsg = useCallback(() => setToastMsgOpen(false), []);

  const handleDeleteAccount = () => {
    // Placeholder for delete account logic
    openToastMsg();
  };

  const tabs = [
    { label: "Profile", to: "/setting-account" },
    { label: "Connected accounts", to: "/setting-account2" },
    { label: "Security", to: "/setting-account3" },
    { label: "Delete account", to: "/setting-account4" },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&display=swap');
        html, body { background: rgb(241, 245, 249) !important; }
        .dd-root * { box-sizing: border-box; }
        .dd-root { font-family: 'DM Sans', sans-serif; background: rgb(241, 245, 249) !important; min-height: 100vh; }
        .dd-card { background: #ffffff; border: 1px solid #E2E8F0; border-radius: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 2px 12px rgba(0,0,0,0.04); transition: box-shadow 0.2s ease; position: relative; overflow: hidden; }
        .dd-section-divider { border: none; border-top: 1px solid #E2E8F0; margin: 0; }
        .dd-section-label { font-size: 14px; font-weight: 700; color: #0F172A; margin: 0 0 12px 0; }
        .dd-section-sublabel { font-size: 13px; color: #64748B; margin: 2px 0 0 0; }
        .dd-btn-secondary { display: inline-flex; align-items: center; gap: 6px; padding: 8px 18px; background: #ffffff; border: 1px solid #E2E8F0; border-radius: 8px; font-family: 'DM Sans', sans-serif; font-size: 13px; font-weight: 600; color: #0F172A; cursor: pointer; box-shadow: 0 1px 2px rgba(0,0,0,0.05); transition: border-color 0.15s, background 0.15s; }
        .dd-btn-secondary:hover { border-color: #94A3B8; background: #F8FAFC; }
        .dd-btn-secondary:disabled { opacity: 0.6; cursor: not-allowed; }
        .dd-btn-primary { display: inline-flex; align-items: center; gap: 6px; padding: 8px 18px; background: #2563EB; border: 1px solid #2563EB; border-radius: 8px; font-family: 'DM Sans', sans-serif; font-size: 13px; font-weight: 600; color: #ffffff; cursor: pointer; transition: background 0.15s, box-shadow 0.15s; }
        .dd-btn-primary:hover { background: #1D4ED8; box-shadow: 0 4px 12px rgba(37,99,235,0.25); }
        .dd-btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }
        .dd-btn-danger { display: inline-flex; align-items: center; gap: 6px; padding: 8px 18px; background: #EF4444; border: 1px solid #EF4444; border-radius: 8px; font-family: 'DM Sans', sans-serif; font-size: 13px; font-weight: 600; color: #ffffff; cursor: pointer; transition: background 0.15s, box-shadow 0.15s; }
        .dd-btn-danger:hover { background: #DC2626; box-shadow: 0 4px 12px rgba(239,68,68,0.25); }
        .dd-btn-danger:disabled { opacity: 0.6; cursor: not-allowed; }
        .dd-checkbox-row { display: flex; align-items: center; gap: 10px; font-size: 14px; color: #1E293B; }
        .dd-checkbox { width: 18px; height: 18px; border-radius: 5px; border: 1.5px solid #CBD5E1; accent-color: #2563EB; cursor: pointer; flex-shrink: 0; }
      `}</style>

      <div
        className="dd-root w-full overflow-visible"
        style={{ background: "rgb(241, 245, 249)", minHeight: "100vh" }}
      >
        <NavigationPanel />

        <div
          style={{
            position: "absolute",
            top: 136,
            width: "100%",
            padding: "0 96px 64px",
            display: "flex",
            flexDirection: "column",
            gap: 24,
          }}
        >
          <div style={{ borderBottom: "1px solid #E2E8F0", paddingBottom: 24 }}>
            <h1
              style={{
                margin: 0,
                fontSize: 22,
                fontWeight: 700,
                color: "#0F172A",
              }}
            >
              Settings
            </h1>
            <p style={{ margin: "4px 0 0", fontSize: 14, color: "#64748B" }}>
              Get your billing information, generate/review invoices.
            </p>
          </div>

          <div style={{ display: "flex", alignItems: "flex-start", gap: 32 }}>
            <SettingNav />

            <div
              className="dd-card"
              style={{
                flex: 1,
                padding: 28,
                display: "flex",
                flexDirection: "column",
                gap: 24,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  paddingBottom: 20,
                  borderBottom: "1px solid #E2E8F0",
                }}
              >
                <div>
                  <div
                    style={{ fontSize: 16, fontWeight: 700, color: "#0F172A" }}
                  >
                    Account
                  </div>
                  <div style={{ fontSize: 13, color: "#64748B", marginTop: 2 }}>
                    Allow users to configure how and when communication is
                    initiated with debtors.
                  </div>
                </div>
                <div style={{ display: "flex", gap: 10, flexShrink: 0 }}>
                  <button className="dd-btn-secondary">Cancel</button>
                  <button className="dd-btn-primary" onClick={openToastMsg}>
                    Save
                  </button>
                </div>
              </div>

              <div style={{ display: "flex", gap: 8, marginBottom: -8 }}>
                {tabs.map((tab) => (
                  <TabState key={tab.to} label={tab.label} to={tab.to} />
                ))}
              </div>

              <hr className="dd-section-divider" />

              <div
                style={{
                  padding: 24,
                  borderRadius: 12,
                  border: "1px solid #FECACA",
                  background: "#FEF2F2",
                  display: "flex",
                  flexDirection: "column",
                  gap: 20,
                }}
              >
                <div>
                  <p
                    className="dd-section-label"
                    style={{ margin: 0, color: "#991B1B" }}
                  >
                    Deleting your account will permanently remove all personal
                    data and revoke access.
                  </p>
                </div>
                <label className="dd-checkbox-row" style={{ color: "#1E293B" }}>
                  <input
                    type="checkbox"
                    className="dd-checkbox"
                    checked={confirmDelete}
                    onChange={(e) => setConfirmDelete(e.target.checked)}
                    style={{ accentColor: "#EF4444" }}
                  />
                  <span>I understand this action cannot be undone.</span>
                </label>
                <button
                  className="dd-btn-danger"
                  onClick={handleDeleteAccount}
                  disabled={!confirmDelete}
                  style={{ alignSelf: "flex-start" }}
                >
                  Delete My Account
                </button>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>

      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
      {isToastMsgOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeToastMsg}
        >
          <ToastMsg onClose={closeToastMsg} />
        </PortalPopup>
      )}
    </>
  );
};

export default SettingsAccount4Page;
